import { useId } from 'react';

import { css } from '@compiled/react';

export const ServiceCollectionAtlassianLogo = ({
	size = 'default',
}: {
	readonly size?: 'default' | 'small';
}) => {
	const titleId = useId();

	return (
		<svg
			viewBox="0 0 196 57"
			css={[logoCss, size === 'small' && logoSmallCss]}
			fill="none"
			role="img"
			aria-labelledby={titleId}
		>
			<title id={titleId}>Atlassian Service Collection</title>
			<rect
				x="1.53662"
				y="4.39697"
				width="92.8573"
				height="44.0272"
				transform="rotate(2 1.53662 4.39697)"
				fill="#FFC716"
			/>
			<path
				d="M77.98 25.9005C76.9265 25.9005 76.3886 26.6626 76.2541 28.1643L79.6386 28.1643C79.5265 26.5953 78.9886 25.9005 77.98 25.9005ZM83.0007 34.3505C81.9024 34.754 80.4007 35.0454 78.899 35.0454C74.2593 35.0454 72.1748 33.0057 72.1748 29.1954C72.1748 25.5419 74.192 22.9419 78.0472 22.9419C81.8576 22.9419 83.4265 25.5195 83.4265 29.1954L83.4265 30.0695L76.3438 30.0695C76.6127 31.2126 77.3972 31.5712 78.9886 31.5712C80.3334 31.5712 81.8128 31.3695 83.0007 31.0333L83.0007 34.3505Z"
				fill="#101214"
			/>
			<path
				d="M71.3189 30.7419L71.3189 34.3505C70.5344 34.7988 69.5258 35.0678 68.2931 35.0678C64.0344 35.0678 62.062 32.5574 62.062 28.9936C62.062 25.4747 64.0344 22.9419 68.0241 22.9419C69.4138 22.9419 70.2655 23.1884 71.2741 23.6591L71.2741 27.3126C70.5344 26.9764 69.7724 26.7522 68.6965 26.7522C66.9482 26.7522 66.231 27.7833 66.231 28.9936C66.231 30.2488 67.0379 31.1678 68.8086 31.1678C70.0189 31.1678 70.6689 30.9885 71.3189 30.7419Z"
				fill="#101214"
			/>
			<path
				d="M56.1074 19.9834C56.1074 18.5265 57.2057 17.6748 58.685 17.6748C60.2092 17.6748 61.285 18.5265 61.285 19.9834C61.285 21.4627 60.2092 22.3145 58.685 22.3145C57.2057 22.3145 56.1074 21.4627 56.1074 19.9834ZM56.5781 34.8214L56.5781 23.211L60.8143 23.211L60.8143 34.8214L56.5781 34.8214Z"
				fill="#101214"
			/>
			<path
				d="M52.7815 34.8213L46.9091 34.8213L43.8608 23.2109L47.985 23.2109L49.8902 31.8403L51.7953 23.2109L55.8298 23.2109L52.7815 34.8213Z"
				fill="#101214"
			/>
			<path
				d="M40.4583 29.1955L40.4583 34.8214L36.1997 34.8214L36.1997 23.211L40.4583 23.211L40.4583 25.4076C41.0635 23.8386 42.0049 22.9645 43.529 23.0541L43.529 27.4024C41.2652 27.2455 40.4583 27.6938 40.4583 29.1955Z"
				fill="#101214"
			/>
			<path
				d="M29.4751 25.9005C28.4217 25.9005 27.8837 26.6626 27.7492 28.1643L31.1337 28.1643C31.0217 26.5953 30.4837 25.9005 29.4751 25.9005ZM34.4958 34.3505C33.3975 34.754 31.8958 35.0454 30.3941 35.0454C25.7544 35.0454 23.6699 33.0057 23.6699 29.1954C23.6699 25.5419 25.6872 22.9419 29.5423 22.9419C33.3527 22.9419 34.9217 25.5195 34.9217 29.1954L34.9217 30.0695L27.8389 30.0695C28.1079 31.2126 28.8923 31.5712 30.4837 31.5712C31.8286 31.5712 33.3079 31.3695 34.4958 31.0333L34.4958 34.3505Z"
				fill="#101214"
			/>
			<path
				d="M22.8115 30.2043C22.8115 33.2526 21.0856 35.0681 16.827 35.0681C14.227 35.0681 12.3442 34.4854 11.1339 33.8354L11.1339 29.8009C12.5011 30.4285 15.0787 31.1233 16.7822 31.1233C17.8132 31.1233 18.1943 30.7871 18.1943 30.2491C18.1943 29.6888 17.746 29.375 16.5805 29.1509C12.2098 28.4336 10.9546 26.7078 10.9546 24.4664C10.9546 21.575 13.0839 19.8491 16.9839 19.8491C19.046 19.8491 20.996 20.2974 22.2512 20.9698L22.2512 24.8698C20.346 24.1526 18.1494 23.6819 16.8718 23.6819C15.908 23.6819 15.4149 23.9733 15.4149 24.5336C15.4149 25.094 15.9305 25.3629 17.477 25.6543C21.7805 26.3491 22.8115 28.0078 22.8115 30.2043Z"
				fill="#101214"
			/>
			<path
				d="M161.975 8.08297C161.975 6.55209 161.155 5.82787 158.867 5.32872C157.595 5.05463 157.29 4.76494 157.29 4.36161C157.29 3.86245 157.74 3.63739 158.578 3.63739C159.594 3.63739 160.592 3.94267 161.541 4.3772V2.36499C160.881 2.02628 159.85 1.77002 158.642 1.77002C156.372 1.77002 155.198 2.75273 155.198 4.37943C155.198 5.66743 155.793 6.69916 158.143 7.14929C159.545 7.43898 159.834 7.66404 159.834 8.132C159.834 8.59995 159.545 8.87181 158.547 8.87181C157.404 8.87181 156.036 8.48631 155.149 7.95373V10.064C155.858 10.4183 156.791 10.8038 158.531 10.8038C161.01 10.8038 161.975 9.70968 161.975 8.08297Z"
				fill="#101214"
			/>
			<path
				d="M186.751 1.89941V10.6769H188.618V3.97848L189.407 5.76562L192.049 10.6769H194.399V1.89941H192.53V7.56837L191.822 5.92607L189.696 1.89941H186.751Z"
				fill="#101214"
			/>
			<path d="M174.87 1.89941H172.825V10.6591H174.87V1.89941Z" fill="#101214" />
			<path
				d="M170.475 8.08297C170.475 6.55209 169.653 5.82787 167.368 5.32872C166.096 5.05463 165.79 4.76494 165.79 4.36161C165.79 3.86245 166.24 3.63739 167.078 3.63739C168.092 3.63739 169.09 3.94267 170.041 4.3772V2.36499C169.381 2.02628 168.35 1.77002 167.143 1.77002C164.873 1.77002 163.696 2.75273 163.696 4.37943C163.696 5.66743 164.293 6.69916 166.641 7.14929C168.043 7.43898 168.332 7.66404 168.332 8.132C168.332 8.59995 168.043 8.87181 167.045 8.87181C165.902 8.87181 164.534 8.48631 163.647 7.95373V10.064C164.356 10.4183 165.289 10.8038 167.029 10.8038C169.508 10.8038 170.475 9.70968 170.475 8.08297Z"
				fill="#101214"
			/>
			<path
				d="M139.356 1.89941V10.6769H143.557L144.219 8.77614H141.417V1.89941H139.356Z"
				fill="#101214"
			/>
			<path
				d="M131.081 1.89941V3.80021H133.333V10.6769H135.393V3.80021H137.826V1.89941H131.081Z"
				fill="#101214"
			/>
			<path
				d="M126.75 7.61614C126.364 7.61614 125.977 7.55152 125.622 7.4557L126.75 3.62292L127.877 7.4557C127.523 7.55152 127.137 7.61614 126.75 7.61614ZM128.102 1.90039H125.413L122.354 10.6601H124.689L125.123 9.17823C125.638 9.32307 126.186 9.42112 126.765 9.42112C127.344 9.42112 127.877 9.3409 128.407 9.17823L128.841 10.6601H131.176L128.102 1.90039Z"
				fill="#101214"
			/>
			<path
				d="M149.449 7.61614C149.063 7.61614 148.676 7.55152 148.322 7.4557L149.449 3.62292L150.576 7.4557C150.206 7.55152 149.836 7.61614 149.449 7.61614ZM150.785 1.90039H148.097L145.038 10.6601H147.373L147.807 9.17823C148.322 9.32307 148.87 9.42112 149.449 9.42112C150.028 9.42112 150.56 9.3409 151.091 9.17823L151.525 10.6601H153.86L150.785 1.90039Z"
				fill="#101214"
			/>
			<path
				d="M180.875 7.61614C180.49 7.61614 180.102 7.55152 179.748 7.4557L180.875 3.62292L182.002 7.4557C181.648 7.55152 181.278 7.61614 180.875 7.61614ZM182.227 1.90039H179.539L176.48 10.6601H178.815L179.249 9.17823C179.764 9.32307 180.312 9.42112 180.891 9.42112C181.47 9.42112 182.002 9.3409 182.533 9.17823L182.967 10.6601H185.302L182.227 1.90039Z"
				fill="#101214"
			/>
			<path
				d="M170.475 8.08312C170.475 6.55223 169.671 5.82802 167.368 5.32886C166.096 5.05478 165.79 4.76509 165.79 4.36175C165.79 3.8626 166.24 3.63754 167.078 3.63754C168.092 3.63754 169.09 3.94282 170.041 4.37735V2.36514C169.139 1.94621 168.141 1.75234 167.143 1.77017C164.873 1.77017 163.696 2.75288 163.696 4.37958C163.696 5.66757 164.293 6.69931 166.641 7.14944C168.043 7.43912 168.332 7.66419 168.332 8.13214C168.332 8.6001 168.043 8.87196 167.045 8.87196C165.853 8.85636 164.679 8.53325 163.647 7.95388V10.0641C164.356 10.4184 165.289 10.804 167.029 10.804C169.493 10.804 170.457 9.70983 170.475 8.08312Z"
				fill="#101214"
			/>
			<path
				d="M194.461 28.3586V35.083H192.488V28.1521C192.488 26.0865 191.661 25.1685 189.78 25.1685C187.943 25.1685 186.681 26.3849 186.681 28.7029V35.083H184.708V23.6079H186.681V25.4898C187.416 24.1358 188.77 23.3784 190.307 23.3784C192.947 23.3784 194.461 25.1915 194.461 28.3586Z"
				fill="#292A2E"
			/>
			<path
				d="M176.997 35.3125C173.555 35.3125 171.535 32.765 171.535 29.3225C171.535 25.88 173.555 23.3784 176.997 23.3784C180.417 23.3784 182.414 25.88 182.414 29.3225C182.414 32.765 180.417 35.3125 176.997 35.3125ZM176.997 25.2144C174.542 25.2144 173.463 27.1422 173.463 29.3225C173.463 31.5028 174.542 33.4765 176.997 33.4765C179.43 33.4765 180.486 31.5028 180.486 29.3225C180.486 27.1422 179.43 25.2144 176.997 25.2144Z"
				fill="#292A2E"
			/>
			<path
				d="M166.903 20.5787C166.903 19.7066 167.477 19.2017 168.28 19.2017C169.084 19.2017 169.657 19.7066 169.657 20.5787C169.657 21.4508 169.084 21.9557 168.28 21.9557C167.477 21.9557 166.903 21.4508 166.903 20.5787ZM167.271 35.0832V23.6081H169.244V35.0832H167.271Z"
				fill="#292A2E"
			/>
			<path
				d="M161.687 31.5258C161.687 32.5356 162.283 33.2241 163.5 33.2241C163.959 33.2241 164.395 33.1323 164.739 33.0635V34.9683C164.395 35.0601 164.005 35.1519 163.408 35.1519C160.952 35.1519 159.759 33.7061 159.759 31.5717V25.444H157.9V23.608H159.759V21.1753H161.687V23.608H164.739V25.444H161.687V31.5258Z"
				fill="#292A2E"
			/>
			<path
				d="M156.703 33.0175V34.7847C156.014 35.1519 154.958 35.3125 153.903 35.3125C149.817 35.3125 147.913 32.8339 147.913 29.3225C147.913 25.857 149.817 23.3784 153.903 23.3784C154.935 23.3784 155.739 23.5161 156.634 23.9292V25.7652C155.899 25.421 155.119 25.2144 154.04 25.2144C151.057 25.2144 149.84 27.0963 149.84 29.3225C149.84 31.5487 151.08 33.4306 154.086 33.4306C155.257 33.4306 155.991 33.2699 156.703 33.0175Z"
				fill="#292A2E"
			/>
			<path
				d="M141.202 25.1685C139.113 25.1685 138.058 26.5226 137.851 28.5193H144.254C144.139 26.3849 143.176 25.1685 141.202 25.1685ZM145.608 34.624C144.667 35.1289 143.221 35.3125 142.051 35.3125C137.759 35.3125 135.877 32.8339 135.877 29.3225C135.877 25.857 137.805 23.3784 141.294 23.3784C144.828 23.3784 146.251 25.8341 146.251 29.3225V30.2176H137.874C138.15 32.1683 139.412 33.4306 142.12 33.4306C143.451 33.4306 144.576 33.1781 145.608 32.8109V34.624Z"
				fill="#292A2E"
			/>
			<path
				d="M134.779 35.0602C134.618 35.1061 134.274 35.152 133.769 35.152C131.887 35.152 130.694 34.257 130.694 32.1456V18.8115H132.668V31.9161C132.668 32.9488 133.356 33.316 134.205 33.316C134.412 33.316 134.549 33.316 134.779 33.2931V35.0602Z"
				fill="#292A2E"
			/>
			<path
				d="M128.795 35.0602C128.634 35.1061 128.29 35.152 127.785 35.152C125.903 35.152 124.709 34.257 124.709 32.1456V18.8115H126.683V31.9161C126.683 32.9488 127.372 33.316 128.221 33.316C128.427 33.316 128.565 33.2931 128.795 33.2931V35.0602Z"
				fill="#292A2E"
			/>
			<path
				d="M117 35.3125C113.557 35.3125 111.538 32.765 111.538 29.3225C111.538 25.88 113.557 23.3784 117 23.3784C120.419 23.3784 122.416 25.88 122.416 29.3225C122.416 32.765 120.419 35.3125 117 35.3125ZM117 25.2144C114.544 25.2144 113.465 27.1422 113.465 29.3225C113.465 31.5028 114.544 33.4765 117 33.4765C119.432 33.4765 120.488 31.5028 120.488 29.3225C120.488 27.1422 119.432 25.2144 117 25.2144Z"
				fill="#292A2E"
			/>
			<path
				d="M110.09 32.4209V34.4176C109.149 35.0373 107.657 35.3127 106.097 35.3127C101.139 35.3127 98.3394 32.3291 98.3394 27.5784C98.3394 22.9884 101.139 19.7754 106.051 19.7754C107.519 19.7754 108.988 20.0508 110.067 20.8311V22.8278C108.988 22.1393 107.795 21.7721 106.051 21.7721C102.516 21.7721 100.405 24.113 100.405 27.5784C100.405 31.0439 102.585 33.3389 106.165 33.3389C107.749 33.3389 108.988 32.9717 110.09 32.4209Z"
				fill="#292A2E"
			/>
		</svg>
	);
};

const logoCss = css({
	height: 57,
	maxWidth: '100%',
	width: 'auto',
});

const logoSmallCss = css({
	height: 41,
	maxWidth: '100%',
	width: 'auto',
});
